import { InputHTMLAttributes, forwardRef } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`block w-full border ${
          error ? "border-red-500" : "border-gray-300"
        } rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-200 ${className}`}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export default Input;
